import { FormCustomReadOnlyType, FormFieldProps } from './type'
import { useLayoutEffect, useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const FormCustomReadOnlyField = ({
  data,
  field,
}: FormFieldProps<FormCustomReadOnlyType>) => {
  const [isHidden, setIsHidden] = useState(!!data.isHidden)
  const __DEV_EFFEECT_CALLED_ONCE__ = useRef(false)

  const context = useFormContext()

  const values = context.watch()

  useLayoutEffect(() => {
    if (__DEV_EFFEECT_CALLED_ONCE__.current) {
      return
    }

    __DEV_EFFEECT_CALLED_ONCE__.current = true

    const func = async () => {
      if (values) {
        if (data.isHidden) {
          const _isHidden = await data.isHidden?.(values)
          setIsHidden(!_isHidden)
        }
      }
    }

    func()
  }, [data, values])

  if (isHidden) {
    return null
  }

  return (
    <div className="min-h-8 flex items-center ">
      {data?.render?.(values, context)}
    </div>
  )
}
